/**
 * @file   src\components\Common\TextBox.js
 * @brief  This file is responsible for text box component
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import clsx from "clsx";

const TextBox = (props) => {
  return (
    <>
      <label
        className={clsx(
          props.label ? "d-block" : "d-none",
          props.labelClassName,
          props.errorMessage && "error-form-label",
        )}
      >
        {props.label}
      </label>
      <input
        className={clsx(
          "form-control",
          props.className,
          props.errorMessage && "error-form-control",
        )}
        id={props.id}
        name={props.name}
        type={props.type}
        value={props.value ?? ""}
        placeholder={props.placeholder}
        error={props.error}
        autoComplete={props.autoComplete}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        minLength={props.minLength}
        maxLength={props.maxLength}
        disabled={props.disabled}
        background-color={props.bgColor}
        ref={props.txtRef}
        min={props.minValue}
        max={props.maxValue}
        step={props.step}
        readOnly={props.readonly}
        tabIndex={props.tabIndex}
        autoFocus={props.autoFocus}
        pattern={props.pattern}
        inputMode={props.inputmode}
        onKeyDown={props.onKeyDown}
        style={{
          opacity: props.disabled ? 0.5 : 1,
          cursor: props?.disabled ? 'not-allowed' : 'pointer',
        }}
      />
      {!props.notShowError &&
        (props.errorClass ? (
          <div className={props.errorClass}>{props.errorMessage}</div>
        ) : (
          <div className="error-msg">
            {props.errorMessage && props.errorMessage !== "" && (
              <span className="error-msg">{props.errorMessage}</span>
            )}
          </div>
        ))}
    </>
  );
};

export default TextBox;
